import BrokenImageOutlinedIcon from "@mui/icons-material/BrokenImageOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { useTranslation } from "hhn-commons";
import { MouseEvent } from "react";
import {
  AudioContainer,
  AvatarContainer,
  InlineContainer,
  Label,
  MediaErrorVariant,
} from "./MediaErrorPlaceholder.style";

export type MediaErrorKind = "image" | "video";

const INLINE_ICON_SIZE = 40;

type Props = {
  variant?: MediaErrorVariant;
  kind?: MediaErrorKind;
  onRetry?: () => void;
  "data-testid"?: string;
};

const MediaErrorPlaceholder = ({
  variant = "inline",
  kind = "image",
  onRetry,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const tapToRetry = tNs("message.media.tapToRetry");
  const couldNotLoad = tNs("message.media.loadFailed");
  const testId = rest["data-testid"] ?? "media-error-placeholder";

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (onRetry) onRetry();
  };

  if (variant === "avatar") {
    return (
      <AvatarContainer
        data-testid={testId}
        onClick={onRetry ? handleClick : undefined}
        title={onRetry ? tapToRetry : couldNotLoad}
      >
        <BrokenImageOutlinedIcon fontSize="small" />
      </AvatarContainer>
    );
  }

  if (variant === "audio") {
    return (
      <AudioContainer
        data-testid={testId}
        onClick={onRetry ? handleClick : undefined}
        title={onRetry ? tapToRetry : couldNotLoad}
      >
        <RefreshIcon fontSize="small" />
        <span>{tapToRetry}</span>
      </AudioContainer>
    );
  }

  const InlineIcon =
    kind === "video" ? VideocamOutlinedIcon : ImageOutlinedIcon;

  return (
    <InlineContainer
      data-testid={testId}
      onClick={onRetry ? handleClick : undefined}
      title={onRetry ? tapToRetry : couldNotLoad}
    >
      <InlineIcon sx={{ fontSize: INLINE_ICON_SIZE }} />
      <Label>{tapToRetry}</Label>
    </InlineContainer>
  );
};

export default MediaErrorPlaceholder;
